export class GetTransactionLogsBo {
    startDate: string | null;
    endDate: string | null;
    searchColumn: string = "companyName";
    searchText: string = "";
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string = "companyName";
    orderType: string = "asc";
    type: string = "string";
    field: string = "companyName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    statusType: string;
    payerId:string;
    clientId:string;
    errorCode:string;

}

export class EvvAggregatorTransactionBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    requestPayload: string;
    statusCode: number;
    responseContent: string;
    content: string;
    transactionId: string = "00000000-0000-0000-0000-000000000000";
    createdDate: string;
    sendTimeUtc: string;
    statusCheckScheduleTime: string | null;
    companyName: string;
    errors: string;
    evvTimesheetId: string = "00000000-0000-0000-0000-000000000000";
}